import { getFileExtensionForContentType } from '../utils/Utils';

export default interface ServerAssetUploader {
    /** @returns A Promise that resolves to `true` if asset with given `assetId` is already uploaded. */
    assetExists(assetId: string): Promise<boolean>;

    /** @returns A Promise that resolves with the uploaded asset ID. */
    uploadAsset(opts: { assetId: string; body: Buffer; contentType: string }): Promise<void>;

    /** @returns A Promise that resolves with the uploaded asset ID. */
    uploadDataURLAsset(opts: { dataUrl: string; fileNamePrefix?: string }): Promise<string>;
}

export function parseAssetDataUrl(dataUrl: string) {
    const match = dataUrl.match(/^data:(.*?);base64,(.*)/);
    if (!match) {
        throw new Error('Invalid dataUrl');
    }
    const mediaType = match[1]!;
    const b64 = match[2]!;

    return {
        b64,
        mediaType,
        extension: getFileExtensionForContentType(mediaType),
    };
}
